import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/image/mobile-app-collage.png")